// 注册方式类型
export type RegisterMethod = "phone" | "email";

// 环境变量配置
export const env = {
  // 应用配置
  APP_TITLE: import.meta.env.VITE_APP_TITLE || "IZFUN",
  APP_VERSION: import.meta.env.VITE_APP_VERSION || "1.0.0",
  APP_DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || "Gaming Platform",

  // 开发环境配置
  DEV_MODE: import.meta.env.VITE_DEV_MODE === "true",
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === "true",

  // 主题配置
  DEFAULT_THEME: import.meta.env.VITE_DEFAULT_THEME || "darkred",
  DEFAULT_BRAND: import.meta.env.VITE_DEFAULT_BRAND || "1zfun",
  ENABLE_THEME_SWITCH: import.meta.env.VITE_ENABLE_THEME_SWITCH !== "false",
  SUPPORTED_LANGUAGES: import.meta.env.VITE_SUPPORTED_LANGUAGES || "en,es,pt,ar,bn",
  DEFAULT_LANGUAGE: import.meta.env.VITE_DEFAULT_LANGUAGE || "en",
  I18N_DEBUG: import.meta.env.VITE_I18N_DEBUG === "false",

  // 注册方式配置: phone | email
  REGISTER_METHOD: (import.meta.env.VITE_REGISTER_METHOD ||
    "phone") as RegisterMethod,

  // 功能开关
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === "true",
  ENABLE_PWA: import.meta.env.VITE_ENABLE_PWA === "true",
  ENABLE_OFFLINE_MODE: import.meta.env.VITE_ENABLE_OFFLINE_MODE === "true",
  ENABLE_ANTI_DEBUG: import.meta.env.VITE_ENABLE_ANTI_DEBUG === "true",

  // 第三方服务配置
  GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || "",
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || "",

  // Tawk.to 配置
  TAWK_PROPERTY_ID: import.meta.env.VITE_TAWK_PROPERTY_ID || "",
  TAWK_WIDGET_ID: import.meta.env.VITE_TAWK_WIDGET_ID || "",

  // LiveChat 配置
  LIVECHAT_LICENSE: import.meta.env.VITE_LIVECHAT_LICENSE || "",

  // Web Push 配置
  VAPID_PUBLIC_KEY: import.meta.env.VITE_VAPID_PUBLIC_KEY || "",

  // 社交媒体链接配置
  SOCIAL_FACEBOOK_PAGE:
    import.meta.env.VITE_SOCIAL_FACEBOOK_PAGE || "https://www.facebook.com",
  SOCIAL_FACEBOOK_GROUP:
    import.meta.env.VITE_SOCIAL_FACEBOOK_GROUP ||
    "https://www.facebook.com/groups",
  SOCIAL_TELEGRAM: import.meta.env.VITE_SOCIAL_TELEGRAM || "https://t.me",
  SOCIAL_WHATSAPP: import.meta.env.VITE_SOCIAL_WHATSAPP || "",
  SOCIAL_FACEBOOK_FOOTER: "https://www.facebook.com/DeskAceofficial/",
  SOCIAL_TELEGRAM_FOOTER: "https://t.me/deskaceofficial",
  SOCIAL_VIBER_FOOTER:
    "https://connect.viber.com/en/business/47280eb8-066c-11f1-a80a-b2e03db0b965",

  // 构建配置
  BUILD_SOURCEMAP: import.meta.env.VITE_BUILD_SOURCEMAP !== "false",
  BUILD_MINIFY: import.meta.env.VITE_BUILD_MINIFY !== "false",
  ENABLE_CONSOLE: import.meta.env.VITE_ENABLE_CONSOLE === "true",
  ENABLE_DEBUGGER: import.meta.env.VITE_ENABLE_DEBUGGER === "true",
} as const;

// 环境检查
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;
export const mode = import.meta.env.MODE;

// 开发环境下的环境变量调试
if (isDevelopment) {
  console.log("环境变量配置:", {
    mode,
    isDevelopment,
    isProduction,
    env: {
      APP_TITLE: env.APP_TITLE,
      DEV_MODE: env.DEV_MODE,
      DEBUG_MODE: env.DEBUG_MODE,
      ENABLE_CONSOLE: env.ENABLE_CONSOLE,
      ENABLE_DEBUGGER: env.ENABLE_DEBUGGER,
      BUILD_SOURCEMAP: env.BUILD_SOURCEMAP,
      BUILD_MINIFY: env.BUILD_MINIFY,
    },
  });
}
